export function destinationLabel(destination) {
  const details = destination.snapshot || destination;
  const name = destination.label || details.name;
  const type = details.address_type || (details.type && !["customer_address", "business_location"].includes(details.type) ? details.type : null);
  return [...new Set([name, type, details.address].filter(Boolean))].join(" · ") || "Address";
}

export function isPaymentSettled(financial) {
  return !!financial?.invoice_locked && Number(financial.invoice_total) > 0
    && financial.due_amount != null && financial.due_amount !== ""
    && Number.isFinite(Number(financial.due_amount)) && Number(financial.due_amount) === 0;
}
